<template>
  <div>
    <div v-show="!loading" v-if="!loading">
      <table-cadu
        nameTab="historico"
        :class="$vuetify.breakpoint.xs ? 'competencia-mobile' : 'competencia'"
        v-model="selected"
        custom
        :disabledButtons="disabledButtons"
        :showFiltro="false"
        :showCheck="false"
        :rows="conteudo"
        :rowsHeader="rowsHeader"
        :qtResultados="conteudo.length"
        :pagina="currentPagina"
        :qtPaginas="quantidadesPaginas"
        :elementsPerPageProp="this.elementsPerPage"
        :items="['05', '10', '15']"
        :loading="loading"
        @clickButton="(action) => getAction(action)"
        @change-element="(element) => changeSelect(element)"
        @change-page="(page) => changePage(page.currentPage)"
        @ordena="(obj) => changeOrdem(obj)"
      >
      </table-cadu>
    </div>
    <component-loading :value="loading" />
  </div>
</template>

<script>
import jwtDecode from 'jwt-decode'

import Selo from '@/services/Selos/Selo'

export default {
  props: {
    objetoSelos: {
      type: Object,
      require: false
    },
    rows: {
      type: Array,
      require: true
    },
    pagina: {
      type: Number,
      require: true
    },
    qtPaginas: {
      type: Number,
      required: true
    },
    listaSelosBloqueados: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selected: [],

      // Table Historico
      rowsHeader: [
        { text: 'Selo/Certificação', icon: 'repeat' },
        { text: 'Instituição Responsável', icon: 'repeat' },
        { text: 'Data Início', icon: 'repeat' },
        { text: 'Data Fim', icon: 'repeat' },
        { text: 'Nível' },
        { text: 'Status' }
      ],
      currentPagina: this.pagina,
      conteudo: this.rows,
      quantidadesPaginas: this.qtPaginas,
      resultadosPaginas: this.qtResultados,
      elementsPerPage: 5,
      firstLoad: true,

      ordem: 'desc',
      ordemStatus: '',
      bool: false,

      role: '',
      disabledButtons: [false, false, false],
      tokenBearer: '',
      opcaoEditar: false,
      loading: false,
      type: '',
      tipoDeVigencia: 'TODOS'
    }
  },
  beforeMount() {
    this.tokenBearer = localStorage.getItem('tokenBearer')
    this.opcaoEditar = JSON.parse(localStorage.getItem('optionEdit'))
    let decoded = jwtDecode(this.tokenBearer)
    this.role = decoded.role
    this.permissaoBotoes()
  },
  computed: {
    canEdit() {
      return this.role === 'admin_brasil' || this.role === 'admin' || this.role === 'dirigente'
    },

    args() {
      return `ordenacao=${this.ordemStatus}&direcaoOrdenacao=${this.ordem}&tamanhoPagina=${this.elementsPerPage}&pagina=${this.currentPagina}`
    }
  },
  methods: {
    changeSelect(element) {
      if (element.elementsPerPage !== this.conteudo.length && this.currentPagina < this.quantidadesPaginas) {
        this.elementsPerPage = element
        this.getSelos(this.args)
      } else {
        this.elementsPerPage = element
        this.currentPagina = 1
        this.getSelos(this.args)
      }
    },

    changePage(pagina) {
      this.currentPagina = pagina
      this.getSelos(this.args)
    },

    changeOrdem(obj) {
      this.ordem = this.ordem === 'asc' ? 'desc' : 'asc'
      switch (obj.index) {
        case 0:
          this.ordemStatus = 'tipoSelo.nome'
          break
        case 1:
          this.ordemStatus = 'instituicaoResponsavel.nome'
          break
        case 2:
          this.ordemStatus = 'dataInicio'
          break
        case 3:
          this.ordemStatus = 'dataFim'
          break
        default:
          this.ordemStatus = ''
          break
      }
      this.getSelos(this.args)
    },

    async getSelos(args) {
      this.loading = true
      let selo = new Selo(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      try {
        let responseSelo = await selo.getSelo(args)
        this.conteudo = responseSelo.data.conteudo
        this.currentPagina = responseSelo.data.pagina
        this.quantidadesPaginas = responseSelo.data.qtPaginas
        this.loading = false
      } catch (err) {
        console.error(err)
      }
    },

    getAction({ type, index }) {
      switch (type) {
        case 'view':
          this.$emit('visualizar', { obj: this.conteudo[index], action: type })
          break
        case 'edit':
          this.$emit('editar', { obj: this.conteudo[index], action: type })
          break
        case 'delete':
          this.$emit('excluir', [this.conteudo[index].id])
      }
    },

    argsPadrao() {
      return `tamanhoPagina=${this.elementsPerPage}&pagina=${this.currentPagina}&vigencia=${this.tipoDeVigencia}`
    },
    permissaoBotoes() {
      if (this.verifyPermission() && this.isEditar()) {
        this.disabledButtons = [true, true, true]
      } else {
        this.disabledButtons = [true, false, false]
      }

      this.conteudo.map((c) => {
        c.bloquearBotaoExcluir = this.listaSelosBloqueados.includes(c.tipoSelo.nome)
      })
    },
    verifyPermission() {
      if (this.role === 'admin_brasil' || this.role === 'admin' || this.role === 'dirigente') {
        return true
      } else {
        return false
      }
    },

    isEditar() {
      if (this.opcaoEditar === true) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="sass">
.competencia > .table-cadu > .table tbody tr td:last-child
  width: 50px

.competencia-mobile > .table-cadu
  padding: 20px 10px !important
  border: none
  border-radius: 0px
  width: 100% !important

.competencia > .table-cadu
  border: none
  border-radius: 0px
  width: 100% !important

.competencia > .table-cadu > .table > table
  width: 100% !important

.competencia-mobile > .table-cadu > .table > table
  width: 100% !important
</style>
